import { Money } from '@ap/interface-bspc-core';

class MoneyBuilder {
    private amount: number;

    constructor(amount?: number) {
        this.amount = amount;
    }

    withAmount(amount: number): this {
        this.amount = amount;
        return this;
    }

    build(): Money {
        return {
            amount: this.amount
        } as Money;
    }
}

export function money(amount: string | number): Money {
    if (amount === undefined || amount === null) {
        return null;
    }
    return new MoneyBuilder().withAmount(Number.parseInt(String(amount), 10)).build();
}
